import { memo, useState, useEffect } from 'react';
import { Dialog, List, ListItem, ListItemText } from '@material-ui/core';
import { ZipResponse } from 'hooks/UseSearchAddress';
import classes from './select-address-dialog.module.scss';

type Props = {
	isOpen: boolean;
	data: ZipResponse[];
	doSelect: Function;
	doClose: Function;
};
/**
 * 住所検索複数ヒット時の選択ダイアログ
 */
export const SelectAddressDialog = memo((props: Props) => {
	const { isOpen, data, doSelect, doClose } = props;
	const [open, setOpen] = useState(false);
	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	return (
		<>
			<Dialog onClose={() => doClose()} open={open}>
				<div className={classes.wrap}>
					<List component="nav">
						{data.map((d, i) => {
							return (
								<ListItem button onClick={() => doSelect(data[i])}>
									<ListItemText primary={`${d.zipcode} ${d.address1} ${d.address2} ${d.address3}`} />
								</ListItem>
							);
						})}
					</List>
				</div>
			</Dialog>
		</>
	);
});
